export const INVOICE_PAYMENT_ALLOWED = "invoicePaymentAllowed";
export const CASH_ON_DELIVERY_PAYMENT_ALLOWED = "codPaymentAllowed";

export const INVOICE_PAYMENT_METHODS = [
  { label: "Invoice", value: INVOICE_PAYMENT_ALLOWED },
  {
    label: "Cash on Delivery",
    value: CASH_ON_DELIVERY_PAYMENT_ALLOWED,
  },
];

export const INVOICE_PAYMENT_STATUS = {
  PENDING: "pending",
  PAID: "paid",
  FAILED: "failed",
};

export const INVOICE_STATUSES = {
  DRAFT: "Draft",
  PENDING: "Pending",
  PAID: "Paid",
  CANCELLED: "Cancelled",
  INVOICED: "Invoiced",
};
